import { gql } from "@apollo/client";

export const lensCompoundIdFragment = gql`
    fragment LensCompoundId on CameraKitLens {
        compoundId {
            id
            reference
            lensSourceType
        }
    }
`;
